"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _SelectedAssets = _interopRequireDefault(require("./SelectedAssets"));

var _BulkActionOptions = _interopRequireDefault(require("./BulkActionOptions"));

var _Labels = _interopRequireDefault(require("./Labels"));

var _Tags = _interopRequireDefault(require("./Tags"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var getLabelsToRemove = function getLabelsToRemove(labels, selectedLabels) {
  if (!labels) {
    return [];
  }

  return labels.filter(function (label) {
    return !selectedLabels.includes(label);
  });
};

var getLabelsToAdd = function getLabelsToAdd(labels, selectedLabels) {
  if (!labels) {
    return selectedLabels;
  } // Unique array elements


  return _toConsumableArray(new Set([].concat(_toConsumableArray(labels), _toConsumableArray(selectedLabels))));
};

var getUpdatedTags = function getUpdatedTags(_ref) {
  var selectedAssets = _ref.selectedAssets,
      assetsMap = _ref.assetsMap,
      tagsToUpdate = _ref.tagsToUpdate,
      add = _ref.add;
  return selectedAssets.map(function (assetId) {
    var _ref2 = assetsMap.get(assetId) || {},
        tags = _ref2.tags;

    if (!tags) {
      return {
        assetId: assetId,
        tags: add ? tagsToUpdate : null
      };
    }

    var presentTagsArr = tags.split(',');
    var tagsToUpdateArr = tagsToUpdate.split(',');
    return {
      assetId: assetId,
      tags: add ? _toConsumableArray(new Set([].concat(_toConsumableArray(presentTagsArr), _toConsumableArray(tagsToUpdateArr)))).join(',') : presentTagsArr.filter(function (tag) {
        return !tagsToUpdateArr.includes(tag);
      }).join(',') || null
    };
  });
};

var BulkActionModal = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkActionModal, _React$Component);

  var _super = _createSuper(BulkActionModal);

  function BulkActionModal(props) {
    var _this;

    _classCallCheck(this, BulkActionModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_ref3) {
      var value = _ref3.value;
      var radioActive = value === 'add' ? {
        add: true,
        remove: false
      } : {
        add: false,
        remove: true
      };

      _this.setState(radioActive);
    });

    _defineProperty(_assertThisInitialized(_this), "onTagChange", function (tags) {
      _this.setState({
        tags: tags
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLabelSave", function (_ref4) {
      var add = _ref4.add,
          updateProject = _ref4.updateProject,
          assignedLabels = _ref4.assignedLabels;
      var selectedLabels = _this.state.selectedLabels;
      var selectedAssets = _this.props.selectedAssets;
      var updatedLabels = selectedAssets.reduce(function (result, assetId) {
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, assetId, add ? getLabelsToAdd(assignedLabels[assetId], selectedLabels) : getLabelsToRemove(assignedLabels[assetId], selectedLabels)));
      }, {});

      var newLabels = _objectSpread(_objectSpread({}, assignedLabels), updatedLabels);

      updateProject({
        assignedLabels: newLabels
      }, {
        override: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTagSave", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
        var add, tagsToUpdate, _this$props, selectedAssets, assetsMap, updateAssetTags, fetchAssets, updatedTags, _yield$updateAssetTag, data, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                add = _ref5.add;
                tagsToUpdate = _this.state.tags;
                _this$props = _this.props, selectedAssets = _this$props.selectedAssets, assetsMap = _this$props.assetsMap, updateAssetTags = _this$props.updateAssetTags, fetchAssets = _this$props.fetchAssets;
                updatedTags = getUpdatedTags({
                  tagsToUpdate: tagsToUpdate,
                  selectedAssets: selectedAssets,
                  assetsMap: assetsMap,
                  add: add
                });
                _context.next = 6;
                return updateAssetTags(updatedTags);

              case 6:
                _yield$updateAssetTag = _context.sent;
                data = _yield$updateAssetTag.data;
                error = _yield$updateAssetTag.error;

                if (!data || error) {
                  (0, _commonReact.notify)({
                    content: 'Something went wrong.',
                    type: 'error'
                  });
                }

                fetchAssets({
                  assetIds: updatedTags.map(function (_ref7) {
                    var assetId = _ref7.assetId;
                    return assetId;
                  })
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "modalSaveHandler", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, showEditLabel, updateProject, assignedLabels, add;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, showEditLabel = _this$props2.showEditLabel, updateProject = _this$props2.updateProject, assignedLabels = _this$props2.assignedLabels;
              add = _this.state.add;

              if (!showEditLabel) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", void _this.handleLabelSave({
                add: add,
                updateProject: updateProject,
                assignedLabels: assignedLabels
              }));

            case 4:
              return _context2.abrupt("return", void _this.handleTagSave({
                add: add
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onLabelSelected", function (selectedLabels) {
      _this.setState({
        selectedLabels: selectedLabels
      });
    });

    _this.state = {
      selectedLabels: [],
      tags: '',
      add: false,
      remove: false
    };
    return _this;
  }

  _createClass(BulkActionModal, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          visible = _this$props3.visible,
          onClose = _this$props3.onClose,
          showEditLabel = _this$props3.showEditLabel,
          showEditTags = _this$props3.showEditTags,
          selectedAssets = _this$props3.selectedAssets,
          labels = _this$props3.labels;
      var _this$state = this.state,
          add = _this$state.add,
          remove = _this$state.remove,
          selectedLabels = _this$state.selectedLabels,
          tags = _this$state.tags;
      var saveLabelEnabled = (add || remove) && selectedLabels.length > 0;
      var saveTagsEnabled = (add || remove) && tags !== '';
      return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: onClose,
        title: "Edit ".concat(showEditLabel ? 'Labels' : 'Tags'),
        saveText: "Save Changes",
        onSave: this.modalSaveHandler,
        saveDisabled: showEditLabel ? !saveLabelEnabled : !saveTagsEnabled
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "bulk-actions__body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "bulk-actions__selectedAsset-list"
      }, selectedAssets.length && selectedAssets.map(function (assetId, index) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SelectedAssets.default, {
          key: assetId,
          assetId: assetId,
          index: index,
          lastElement: selectedAssets.length - 1 === index
        }), selectedAssets.length - 1 !== index && /*#__PURE__*/_react.default.createElement("hr", null));
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "bulk-actions__bulk-operation"
      }, /*#__PURE__*/_react.default.createElement(_BulkActionOptions.default, {
        onChange: this.onChange,
        showEditLabel: showEditLabel,
        add: add,
        remove: remove
      }), showEditLabel && /*#__PURE__*/_react.default.createElement(_Labels.default, {
        selectedLabels: selectedLabels,
        labels: labels,
        onLabelSelected: this.onLabelSelected
      }), showEditTags && /*#__PURE__*/_react.default.createElement(_Tags.default, {
        tags: tags,
        onTagChange: this.onTagChange
      }))));
    }
  }]);

  return BulkActionModal;
}(_react.default.Component);

exports.default = BulkActionModal;